export const fieldConstants = {
    INGREDIENT_NAME_PLACEHOLDER: 'Enter ingredient name',
    PACKAGING_NAME_PLACEHOLDER: 'Enter packaging material name',
    INGREDIENT_NAME: 'name',
    INGREDIENT_ORIGIN: 'origin',
    INGREDIENT_ORIGIN_PLACEHOLDER: 'Enter origin',
    ADDITIONAL_DETAILS: 'additional_details',
    ACTIVITY_MAPPING_IF: 'activity_mapping_id',
    ADDITIONAL_DETAILS_PLACEHOLDER: 'Enter Additional Information (i.e. Organic)',
    THANK_YOU_TEXT: 'Thanks for your request. We will notify you once the prodcution region has been updated',
    SUBMIT: "Submit"
  };